import translate from "@insite/client-framework/Translate";
import Checkbox, { CheckboxProps } from "@insite/mobius/Checkbox";
import activatePriceToggle from "@store/Store/Data/PriceToggle/Handlers/ActivatePriceToggle";
import { usePriceToggle } from "@store/Store/Data/PriceToggle/Hooks/usePriceToggle";
import { COLORS, TYPOGRAPHY } from "@store/theme/common/design";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { css } from "styled-components";

export interface StorePriceToggleStyles {
    priceToggle?: CheckboxProps;
}

export const storePriceToggleStyles: StorePriceToggleStyles = {
    priceToggle: {
        variant: "toggle",
        labelPosition: "left",
        css: css`
            margin-left: 0;

            > div {
                &[aria-checked="false"] {
                    background-color: ${COLORS.primary.base} !important;
                    border-color: ${COLORS.primary.base} !important;
                    color: ${COLORS.white};
                }

                &[aria-checked="true"] {
                    background-color: ${COLORS.success} !important;
                    border-color: ${COLORS.success} !important;
                    color: ${COLORS.white};
                }
            }
        `,
        typographyProps: {
            size: TYPOGRAPHY.size.smaller,
            weight: TYPOGRAPHY.weight.bold,
        },
    },
};

const StorePriceToggle: React.FC = () => {
    const isPriceToggle = usePriceToggle();
    const dispatch = useDispatch();
    const styles = storePriceToggleStyles;

    useEffect(() => {
        const storedIsPriceToggleOn = localStorage.getItem("isPriceToggleOn");

        if (storedIsPriceToggleOn !== null) {
            dispatch(activatePriceToggle(String(storedIsPriceToggleOn).toLocaleLowerCase() === "true"));
        }
    }, []);

    const onPriceToggleChangeHandler: CheckboxProps["onChange"] = (_, currentValue: boolean) => {
        dispatch(activatePriceToggle(currentValue));
    };

    return (
        <Checkbox
            {...styles.priceToggle}
            checked={isPriceToggle}
            onChange={onPriceToggleChangeHandler}
            hiddenIconText={translate("Toggle your price")}
        >
            {translate("Price")}
        </Checkbox>
    );
};

export default StorePriceToggle;
